module.exports = __webpack_public_path__ + "static/media/avatar-7.3befef8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/avatars/avatar-7.png
// module id = 246
// module chunks = 0